/* eslint-disable @next/next/no-img-element */
import { useEffect, useContext } from "react";
import classnames from "classnames";
import AppContext from "context/app";
import styles from "./cover.module.css";

const Cover = ({ ...props }) => {
  const { title, classes, image } = props;
  const { setTransparentHeader } = useContext(AppContext);

  useEffect(() => {
    setTransparentHeader(true);

    return () => {
      setTransparentHeader(false);
    };
  }, [setTransparentHeader]);

  let titleHtml = null;

  if (title) {
    titleHtml = (
      <h1
        className={classnames("mb-3 text-3xl font-bold text-white lg:text-5xl")}
      >
        {title}
      </h1>
    );
  }
  return (
    <div
      className={classnames("relative w-full bg-black", styles.cover, classes)}
    >
      <figure
        className={classnames(
          "absolute inset-0 bottom-0 w-full",
          styles.figure
        )}
      >
        <img
          className="w-full object-cover object-center"
          src={`https://images.opencoaster.com/767x250/${image.hash}${image.ext}`}
          alt={image.alternativeText ? image.alternativeText : title}
        />
        <figcaption
          className={classnames(
            "absolute bottom-0 right-0 p-1 font-mono text-white text-opacity-75 transition-opacity duration-200 ease-in-out",
            styles.caption
          )}
        >
          {image.caption}
        </figcaption>
      </figure>
      <div className={classnames(styles.titleBg, "relative w-full pb-2 pt-20")}>
        <div className="container mx-auto px-6 sm:px-0">{titleHtml}</div>
      </div>
    </div>
  );
};

export default Cover;
